import request from 'superagent'
import co from 'co'
import storage from 'store'
import msgpack from 'msgpack-lite'
// import Neighborhoods from './static/data/new_neighborhoods';


const getNeighborhoodPromises = (neighborhoods, year) => {
  const neighborhood_sample_promises = [];
  for (let neighborhood of neighborhoods) {
    const neighborhood_name = neighborhood.properties.neighborhood;
    const sample_string = `borough=${neighborhood.properties.borough}&neighborhood=${neighborhood_name}&year=${year}&num_samples=500`;
    let request_promise = request.get(`http://toymaker.local:5000/api/sample?${sample_string}`)
    neighborhood_sample_promises.push(request_promise);
  }
  return neighborhood_sample_promises;
}

const getNeighborhoodsSamples = (store, year, next) => {
  let {neighborhoods, neighborhoods_samples} = store.getState();
  if (!neighborhoods_samples) neighborhoods_samples = {};
  if (neighborhoods_samples[year] === undefined) {
    // Check localStorage
    let storage_sample_check = storage.get('neighborhoods_samples');
    if (storage_sample_check !== undefined && storage_sample_check[year] !== undefined) {
      return next({
        type: 'GOT_NEIGHBORHOODS_SAMPLES',
        payload: {
          neighborhoods_samples: storage_sample_check
        }
      })
    } else {
      const neighborhood_promises = getNeighborhoodPromises(neighborhoods, year);
      co(function *(){
        const sample_response_array = yield neighborhood_promises;
        let returned_neighborhoods_samples = sample_response_array.map((response, i) => {
          const samples = JSON.parse(response.text);
          let sample_prices = samples.map((sample) => Math.round(sample.price));
          return sample_prices;
        });
        neighborhoods_samples[year] = returned_neighborhoods_samples;
        storage.set('neighborhoods_samples', neighborhoods_samples);
        return next({
          type: 'GOT_NEIGHBORHOODS_SAMPLES',
          payload: {
            neighborhoods_samples
          }
        })
      }).catch((err) => {
        console.error(err.stack);
      });
    }
  } else {
    return next({
      type: 'GOT_NEIGHBORHOODS_SAMPLES',
      payload: {
        neighborhoods_samples
      }
    })
  }
}

const getNeighborhoodHexes = (action, next) => {
  if (action.payload.neighborhood) {
    let neighb_name = action.payload.neighborhood.toLowerCase().replace(/ /g,'_');
    fetch('https://s3.amazonaws.com/fflprototypespub/ff05/neighborhoods_geometry/' + neighb_name + '.geojson')
    .then(function(response) {
      return response.json();
    }).then(function(json) {
      let variation = Math.floor(Math.random() * 10);
      if (variation.toString().length === 1) variation = '0' + variation;
      const url = 'https://s3.amazonaws.com/fflprototypespub/ff05/neighborhoods/' + neighb_name + '_' +  variation + '.msgpck';
      fetch(url)
      .then(function(response) {
        return response.arrayBuffer();
      }).then(function(buffer) {
        let hex_geojson = json.features;
        let hexes = msgpack.decode(new Buffer(buffer));
        let geojson_ids = hex_geojson.map(geo => geo.properties.hexid.toString());
        let sorted_geojson = hexes.locations.map(hexid => {
          let index = geojson_ids.indexOf(hexid);
          return hex_geojson[index];
        })
        const years = [2010,2011,2012,2013,2014,2015,2016,2017,2018];
        let sorted = years.map((year, i) => {
          const year_samples = hexes.samples[year];
          year_samples.map((hex_samples, i) => {
            return hex_samples.sort((a,b) => {
              if (a < b)
                return -1;
              if (a > b)
                return 1;
              return 0;
            });
          });
          return year_samples;
        })
        let hex_samples_sorted = {};
        for (let s of sorted.entries()) {
          let [i, sortee] = s;
          let year = years[i];
          hex_samples_sorted[year] = sortee;
        }
        return next({
          type: 'GOT_NEIGHBORHOOD_HEXES',
          payload: {
            hex_geojson: sorted_geojson,
            hex_samples: hex_samples_sorted
          }
        })
      })
    });
  };
}


const dataService = store => next => action => {
  next(action)
  switch (action.type) {
    case 'GET_NEIGHBORHOOD_HEXES':
      getNeighborhoodHexes(action, next);
      break
    case 'GET_NEIGHBORHOODS_SAMPLES':
      let variation = Math.floor(Math.random() * 10);
      if (variation.toString().length === 1) variation = '0' + variation;
      const url = 'https://s3.amazonaws.com/fflprototypespub/ff05/neighborhoods_' +  variation + '.msgpck'
      fetch(url)
        .then(function(response) {
          return response.arrayBuffer();
        }).then(function(buffer) {
          const json = msgpack.decode(new Buffer(buffer));
          const years = [2010,2011,2012,2013,2014,2015,2016,2017,2018];
          let sorted = years.map((year, i) => {
            const year_samples = json.samples[year];
            year_samples.map((neighborhoods_samples, i) => {
              return neighborhoods_samples.sort((a,b) => {
                if (a < b)
                  return -1;
                if (a > b)
                  return 1;
                return 0;
              });
            });
            return year_samples;
          })
          let neighborhoods_samples_sorted = {};
          for (let s of sorted.entries()) {
            let [i, sortee] = s;
            let year = years[i];
            neighborhoods_samples_sorted[year] = sortee;
          }
          return next({
            type: 'GOT_NEIGHBORHOODS_SAMPLES',
            payload: {
              neighborhoods_samples: neighborhoods_samples_sorted
            }
          })
        })
      break
    default:
      break
  }
}

export default dataService



/** WEBPACK FOOTER **
 ** ./src/data-service.js
 **/